import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { API_BASE_URL } from "../../config";
import AppButton from "../../design-system/components/AppButton";
import AppCallout from "../../design-system/components/AppCallout";
import AppField from "../../design-system/components/AppField";
import AppInput from "../../design-system/components/AppInput";
import AppLink from "../../design-system/components/AppLink";
import { IconChevronLeft } from "../../design-system/icons";
import { LoginSplit } from "../login";
import "../../i18n";
import "../../design-system/styles/tokens.css";
import "../../design-system/styles/components.css";
import "../login/login.css";

// Oeffentliche Seite: Reset-Mail anfordern. Verschickt den Link, der spaeter auf
// /reset_password?company=...&token=... fuehrt.

export default function ForgetPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSending(true);
    try {
      // Der Endpunkt antwortet absichtlich immer gleich — auch bei unbekannter
      // Adresse. Die Bestaetigung ist deshalb bewusst neutral formuliert.
      await axios.post(`${API_BASE_URL}/api/web/password/forgot`, { email });
      setSent(true);
    } catch {
      setError(t("forget_password.no_success", "Email konnte nicht versendet werden."));
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <LoginSplit>
        <div className="v2login__form">
          <div className="v2login__head">
            <h2 className="v2login__title">Prüfe dein Postfach</h2>
            {/* Bewusst neutral: Der Endpunkt bestaetigt nicht, ob es zu dieser
                Adresse ein Konto gibt. */}
            <p className="v2login__subtitle">
              Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir dir
              einen Link zum Zurücksetzen geschickt. Schau auch im Spam-Ordner
              nach, falls nichts ankommt.
            </p>
          </div>

          <div className="v2login__actions">
            <AppButton
              variant="primary"
              size="lg"
              className="v2login__submit"
              onClick={() => navigate("/login")}
            >
              Zum Login
            </AppButton>
          </div>
        </div>
      </LoginSplit>
    );
  }

  return (
    <LoginSplit>
      <div className="v2login__back">
        <AppLink
          onClick={() => navigate("/login")}
          leadingIcon={<IconChevronLeft sx={{ fontSize: 16 }} />}
        >
          {t("forget_password.back", "Zurück")} zum Login
        </AppLink>
      </div>

      <form className="v2login__form" onSubmit={onSubmit}>
        <div className="v2login__head">
          <h2 className="v2login__title">
            {t("forget_password.title", "Passwort Vergessen")}
          </h2>
          <p className="v2login__subtitle">
            Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link, mit dem du
            ein neues Passwort setzen kannst.
          </p>
        </div>

        <div className="v2login__fields">
          <AppField label={t("forget_password.email", "Email")}>
            <AppInput
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="username"
              placeholder="name@firma.ch"
              autoFocus
            />
          </AppField>
        </div>

        {error ? (
          <AppCallout
            variant="error"
            description={error}
            style={{ marginTop: "var(--ds-space-16)" }}
          />
        ) : null}

        <div className="v2login__actions">
          <AppButton
            type="submit"
            variant="primary"
            size="lg"
            className="v2login__submit"
            disabled={sending}
          >
            {sending
              ? "Wird gesendet…"
              : t("forget_password.reset", "Passwort zurücksetzen")}
          </AppButton>
        </div>
      </form>
    </LoginSplit>
  );
}
